import { Badge, BadgeProps } from '@chakra-ui/react';
import { faGem } from '@fortawesome/pro-solid-svg-icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../core/components/Icon/Icon';

export type UpgradeBadgeProps = BadgeProps & { overlay?: boolean };
const overlayProps: BadgeProps = {
  position: 'absolute',
  top: '-15%',
  right: '-15%',
  w: '50%',
  h: '50%',
  minW: '18px',
  minH: '18px',
};

const UpgradeBadge = ({ overlay, ...rest }: UpgradeBadgeProps): ReactElement | null => {
  const { t } = useTranslation();
  return (
    <Badge
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.900"
      border="1px"
      borderColor="gray.800"
      padding={0}
      rounded="full"
      title={t('global.upgrade')}
      {...(overlay ? overlayProps : undefined)}
      {...rest}
    >
      <Icon icon={faGem} color="yellow.400" fontSize=".9em" />
    </Badge>
  );
};
export default UpgradeBadge;
